import type { ReactNode } from "react";
import type { EFFeatureRenderDockContext } from "@/features/runtime/FeatureTypes";

export function renderCaptainUpMissionDock({
	dock,
}: EFFeatureRenderDockContext): ReactNode {
	return (
		<div className="min-w-0 flex-1 h-full">
			<div
				id="efw-mission-host"
				ref={dock.registerDockHost("mission")}
				className="relative h-full w-full"
			/>
		</div>
	);
}

export function renderCaptainUpTournamentDock({
	dock,
}: EFFeatureRenderDockContext): ReactNode {
	return (
		<div className="min-w-0 flex-1 h-full">
			<div
				id="efw-tournament-host"
				ref={dock.registerDockHost("tournament")}
				className="relative h-full w-full"
			/>
		</div>
	);
}